import { shutdownLiveSessionManager } from '@tv2-player/unifiedplayer/src/plugins/Yospace/yospaceManager';
import { YoLog, DebugFlags } from '@yospace/admanagement-sdk';
import { CastReceiverContext } from '../../types/chromecast-caf-receiver/cast.framework';
import { makeMediaObject } from '../../services/media';
import { prepareYospace } from '../../utils/prepareYospace';
import { mediaFilter } from '../extensions';
import { PluginInterface } from './PluginInterface';
import cast from '../../types/chromecast-caf-receiver/index';
import { isDev } from '../../utils/env';

export class YospacePlugin implements PluginInterface {
  init(context: CastReceiverContext) {
    mediaFilter.register(this.mediaTransform.bind(this));
    context.addEventListener(cast.framework.system.EventType.READY, this.setDebugFlags.bind(this));
  }

  async mediaTransform(media: ReturnType<typeof makeMediaObject>, accessToken: string) {
    shutdownLiveSessionManager();
    if (media.metadata?.isLive && media.ads?.vendor === 'YOSPACE_CS') {
      return prepareYospace(media, accessToken);
    }
    return media;
  }

  private setDebugFlags() {
    if (!isDev) return;

    YoLog.setDebugFlags(DebugFlags.DEBUG_VALIDATION);
  }
}
